import { trialDaysLeft } from "@/utils/iap/trial-days";

const isOnSameDay = (d1, d2) => {
    return d1.getFullYear() === d2.getFullYear() &&
    d1.getMonth() === d2.getMonth() &&
    d1.getDate() === d2.getDate();
};

export const isDiscountEligible = () => {
    if (!localStorage.getItem('winwhell')) return false;
    try {
        const d1 = new Date();
        const d2 = new Date(parseInt(localStorage.getItem('winwhell')));
        if (isOnSameDay(d1, d2)) return true;
        return false;
    } catch (e) {
        window.captureException(e);
        return false;
    }
};

export const shouldShowOffer = () => {
    try {
        return false;
        // if (app.$isIOS()) return false; // @TODO: remove when iOS version is ready
        if (localStorage.getItem('winwhell')) return false;
        if (!window.IAP.status.includes('offeringsLoaded')) return;
        if (window.IAP.hasPremiumAccess()) return false;
        if (isMockedProduct('full_access_monthly')) return false;
        let appDashboardOpenCounter = localStorage.getItem('appDashboardOpenCounter') || 0;
        if (appDashboardOpenCounter > 0 && appDashboardOpenCounter % 10 === 0) return true;
        if (trialDaysLeft() <= 2) return true;
        return false;
    } catch (error) {
        window.captureException(error);
        return false;
    }
};

const isMockedProduct = (sku) => {
    try {
        return (window.IAP.products[sku].mocked === true);
    } catch (error) {
        console.error(error);
        return true;
    }
};
